(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire07df"];
var parcelRegister = parcelRequire.register;
parcelRegister("5p3pM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d38cd3234b3827d1$export$2e2bcd8739ae039; });
const $d38cd3234b3827d1$var$thirdpartyTracker = ()=>{
    console.log("thirdpartyTracker");
};
var $d38cd3234b3827d1$export$2e2bcd8739ae039 = $d38cd3234b3827d1$var$thirdpartyTracker;

});

})();
//# sourceMappingURL=thirdparty.1d2a32c6.js.map
